import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { CyberDispatch, CyberState } from './store';

export const useCyberDispatch = (): CyberDispatch =>
  useDispatch<CyberDispatch>();
export const useCyberSelector: TypedUseSelectorHook<CyberState> = useSelector;
